import { Guid } from "@common/guid";

export class ContractDisplayFieldRequest {
    selectedFields: ContractFieldOrderItem[] = [];

    constructor(fields: Array<string>, filterIdToEnum: Record<string, ContractColumn | undefined>) {
        fields.forEach((x, index) => {
            if (Guid.isGuid(x)) {
                this.selectedFields.push({ customFieldId: x, displayOrder: index });
            } else {
                this.selectedFields.push({ column: filterIdToEnum[x], displayOrder: index });
            }
        });
    }
}

export class ContractFieldOrderItem {
    column?: ContractColumn;
    customFieldId?: string; // Using string for Guid
    displayOrder: number = 0;
}

export enum ContractColumn {
    Id,
    UserFriendlyId,
    Name,
    Template,
    ContractType,
    Status,
    ContractManager,
    BusinessAreas,
    AccessBusinessAreas,
    GroupEntityAccess,
    ExternalContractParties,
    StartDate,
    EndDate,
    SignatureDate,
    CreatedDate,
    CurrencyCode,
    TotalAmount,
    FinalizedAmount,
    Documents,
    PaymentTerms,
    Description,
    Note,
    SpecialTerms,
    ReferenceNumber,
    ExpiryNotificationDays,
    Tags,
    VisibleToAllUsers,
    AdditionalUsers,
    ExcludedUsers,
    CounterPartiesWithSubContractors,
    InternalContractParties,
    ModifiedDate,
    RenewalDate,
    AutoRenewal,
}

export function getFilterIdByEnum(enumValue: ContractColumn, filterIdToEnum: Record<string, ContractColumn | undefined>): string | undefined {
    return filterIdToEnum ? Object.keys(filterIdToEnum).find((key) => filterIdToEnum[key] === enumValue) : undefined;
}
